export function ImgFileSql({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 550.801 550.801" xmlns="http://www.w3.org/2000/svg">
      <path 
        fill="currentColor" 
        d="M488.426,197.019H475.2v-63.816c0-0.398-0.063-0.799-0.116-1.202c-0.021-2.534-0.827-5.023-2.562-6.995L366.325,3.694
        c-0.032-0.031-0.063-0.042-0.085-0.076c-0.633-0.707-1.371-1.295-2.151-1.804c-0.231-0.155-0.464-0.285-0.706-0.419
        c-0.676-0.369-1.393-0.675-2.131-0.896c-0.2-0.056-0.38-0.138-0.58-0.19C359.87,0.119,359.037,0,358.193,0H97.2
        c-11.918,0-21.6,9.693-21.6,21.601v175.413H62.377c-17.049,0-30.873,13.818-30.873,30.873v160.545
        c0,17.043,13.824,30.87,30.873,30.87h13.224V529.2c0,11.907,9.682,21.601,21.6,21.601h356.4c11.907,0,21.6-9.693,21.6-21.601
        V419.302h13.226c17.044,0,30.871-13.827,30.871-30.87v-160.54C519.297,210.838,505.47,197.019,488.426,197.019z M97.2,21.605
        h250.193v110.513c0,5.967,4.841,10.8,10.8,10.8h95.407v54.108H97.2V21.605z M357.17,383.211l-10.536,28.233
        c-22.96-6.702-42.103-13.637-63.64-22.739c-3.586-1.424-7.414-2.151-11.243-2.383c-36.371-2.384-70.348-29.184-70.348-81.834
        c0-48.344,30.631-84.712,78.722-84.712c49.297,0,76.339,37.33,76.339,81.358c0,36.619-16.991,62.448-38.296,72.014v0.966
        C330.613,377.716,344.493,380.584,357.17,383.211z M73.364,376.271l7.415-30.143c9.801,5.021,24.883,10.046,40.432,10.046
        c16.761,0,25.6-6.945,25.6-17.471c0-10.052-7.646-15.789-27.032-22.729c-26.799-9.334-44.275-24.174-44.275-47.625
        c0-27.514,22.984-48.573,61.027-48.573c18.185,0,31.59,3.828,41.159,8.131l-8.145,29.431c-6.452-3.106-17.938-7.652-33.729-7.652
        c-15.805,0-23.451,7.174-23.451,15.546c0,10.294,9.089,14.834,29.9,22.729c28.474,10.525,41.887,25.365,41.887,48.104
        c0,27.031-20.822,50.013-65.093,50.013C100.631,386.09,82.448,381.302,73.364,376.271z M453.601,523.353H97.2V419.302h356.4
        V523.353z M481.139,383.686H380.395V222.41h36.608v130.646h64.136V383.686L481.139,383.686z"
      />
      <path 
        fill="currentColor" 
        d="M279.16,248.73c-24.88,0-39.242,24.408-39.242,54.561c-0.248,30.634,14.589,54.08,39.002,54.08
        c24.641,0,39.011-23.214,39.011-54.791C317.931,273.138,304.057,248.73,279.16,248.73z"
      />
    </svg>
  )
}